<div class="overflow-x-auto grow">
    <div class="flex flex-col">
        @if (layerRelation().relatedLayer) {
            <span class="font-medium text-xl pl-2">
                {{ layerRelation().relatedLayer!.name }}
            </span>
            @if (hasRelatedEntities()) {
                <app-custom-table
                    class="h-full"
                    [columns]="columns"
                    [isSelectable]="false"
                    [translateColumns]="true"
                    (sortEvent)="onSortChange($event)">
                    @for (entity of relatedEntities(); track entity.uuid) {
                        <tr>
                            @for (column of columns; track column.key) {
                                <td
                                    class="min-w-8"
                                    [class]="column.key === 'action' ? 'text-right' : ''">
                                    @switch (column.key) {
                                        @case ('entity') {
                                            {{ entity.businessIdentifier || entity.uuid }}
                                        }
                                        @case ('action') {
                                            <div
                                                class="pr-4"
                                                [matTooltip]="'copy' | transloco"
                                                (click)="
                                                    copyBusinessIdentifier(entity.businessIdentifier || entity.uuid)
                                                ">
                                                <span
                                                    class="inline-flex items-center justify-center w-8 h-8 bg-white rounded-full">
                                                    <fa-icon
                                                        size="lg"
                                                        [icon]="['far', 'copy']" />
                                                </span>
                                            </div>
                                        }
                                    }
                                </td>
                            }
                        </tr>
                    }
                </app-custom-table>
            }
            <div class="flex flex-row justify-between">
                @if (hasRelatedEntities()) {
                    <div class="flex flex-row justify-between">
                        <app-pagination-footer-template
                            [canSearch]="true"
                            [paginationParameters]="paginationParameters()"
                            [searchDisabled]="false"
                            (handleSearch)="onSearch($event)"
                            (onPageChange)="onPageChange($event)" />
                    </div>
                } @else {
                    <span class="pl-4 pt-4">{{ 'noAssociatedEntities' | transloco }}</span>
                }
                @if (projectEditModeService.isEditModeActive()) {
                    <div class="self-center">
                        <app-button
                            [icon]="['fas', 'plus']"
                            [label]="'create' | transloco"
                            [type]="ButtonType.SECONDARY"
                            (onClick)="createRelatedEntity()" />
                    </div>
                }
            </div>
        } @else {
            <span class="font-medium text-xl pl-2">
                {{ layerRelation().tableName }}
            </span>
            <span class="pl-4 pt-4">{{ 'layerNotExistProject' | transloco }}</span>
        }
    </div>
</div>
